export const TEXT_TYPING_SECTION_CONTENT_RESOURCE = '@/SECTION_CONTENT';